export default "__VITE_ASSET__2a3fd90a__"